export default "__VITE_ASSET__7e32529c__"